import Contracts = require("./contracts");
import {SessionService} from "../services/session";
import {Config} from "../config";
export enum UserType {NONE, GUEST, HOST}

export class User {

  user_id: number;
  email: string;
  token: string;
  refreshToken: string;
  city: string;
  city_state: string;
  address: string;
  address_secondary: string;
  location: string;
  birthDate: Date;
  phone: string;
  bio: string;
  type: UserType;
  hostRequested: boolean;
  state: string;

  firstName: string;
  lastName: string;
  avatar: string;

  static createUser(tokenResponse: Contracts.TokenResponse, profileResponse: Contracts.ProfileResponse) {
    var result = new User();
    result.token = User.buildToken(tokenResponse);
    result.refreshProfile(profileResponse);
    return result;
  }

  refreshProfile(profileResponse: Contracts.ProfileResponse) {
    this.user_id = profileResponse.data.id;
    this.firstName = profileResponse.data.first_name;
    this.lastName = profileResponse.data.last_name;
    this.email = profileResponse.data.email;
    this.avatar = User.getUserAvatar(profileResponse);
    this.city = profileResponse.data.city;
    this.city_state = profileResponse.data.city_state;
    this.state = profileResponse.data.state;
    if (profileResponse.data.dob) {
      var date = new Date(profileResponse.data.dob);
      var _userOffset = date.getTimezoneOffset()*60*1000;
      var _utcTime = new Date(date.getTime()+_userOffset);
      if(_utcTime != null) {
        this.birthDate = _utcTime;
      } else {
        this.birthDate = date;
      }
    }
    this.address = profileResponse.data.address;
    this.phone = profileResponse.data.phone;
    this.bio = profileResponse.data.bio;
    this.location = profileResponse.data.location;
    this.type = User.getUserType(profileResponse);
    this.hostRequested = User.isHostRequested(profileResponse);
  }


  private static getUserAvatar(profileResponse: Contracts.ProfileResponse): string {
    if (!profileResponse.data.avatar) {
      return null;
    }
    return profileResponse.data.avatar.m;
  }

  private static getUserType(profileResponse: Contracts.ProfileResponse): UserType {
    switch (profileResponse.data.state) {
      case "guest":
      case "awaiting_for_host":
        return UserType.GUEST;
      case "host":
        return UserType.HOST;
      default:
        return UserType.NONE;
    }
  }

  private static isHostRequested(profileResponse: Contracts.ProfileResponse): boolean {
    return profileResponse.data.state == "awaiting_for_host";
  }

  static buildToken(tokenResponse: Contracts.TokenResponse) {
    return tokenResponse.token_type + " " + tokenResponse.access_token;
  }

  static createFakeUser(type: UserType): User {

    switch(type) {
      case UserType.NONE:
        return new User();
      case UserType.GUEST:
        var result = new User();
        result.type = UserType.GUEST;
        return result;
      case UserType.HOST:
        var result = new User();
        result.type = UserType.HOST;
        return result;
    }
  }

  constructor() {
    this.type = UserType.NONE;
  }
}

export class Covers {
  static covers = function(publicEndpoint) {

    return [
      {
        imgClass: "ot-cover-0",
        uri: "content://cover_0",
        url: Config.publicEndpoint + "assets/cover_0.jpg",
        isActive: false
      },
      {
        imgClass: "ot-cover-1",
        uri: "content://cover_1",
        url: Config.publicEndpoint + "assets/cover_1.jpg",
        isActive: false
      },
      {
        imgClass: "ot-cover-2",
        uri: "content://cover_2",
        url: Config.publicEndpoint + "assets/cover_2.jpg",
        isActive: false
      },
      {
        imgClass: "ot-cover-3",
        uri: "content://cover_3",
        url: Config.publicEndpoint + "assets/cover_3.jpg",
        isActive: false
      }/*,
      {
        imgClass: "ot-cover-4",
        uri: "content://cover_4",
        url: Config.publicEndpoint + "assets/cover_4.jpg",
        isActive: false
      },
      {
        imgClass: "ot-cover-5",
        uri: "content://cover_5",
        url: Config.publicEndpoint + "assets/cover_5.jpg",
        isActive: false
      },
      {
        imgClass: "ot-cover-6",
        uri: "content://cover_6",
        url: Config.publicEndpoint + "assets/cover_6.jpg",
        isActive: false
      }*/
    ];
  }

  static getCoversInstance(publicEndpoint) {
    return Covers.covers(publicEndpoint);
  }

  static urlFromUri(uri: string) {
    for (var i = 0; i < Covers.covers.length; i++) {
      var cover = Covers.covers[i];

      if (cover.uri == uri) {
        return cover.url;
      }
    }
  }

  static isCover(url: string) {
    return url && url.indexOf("cover://") == 0;
  }
}


export enum EventType {PUBLIC, PRIVATE, MANUAL, ALL};
export enum MealType {HOME_COOKED, ORDERED_IN, BUFFET};
export enum AlcoholType {HOST_PROVIDES, BYOB, ALCOHOL_FREE, ALL};
export enum DietType {VEGETARIAN, VEGAN, GLUTEN_FREE, KOSHER, ALL};
export enum CostType {FREE, PAID, ALL};



/** WEBPACK FOOTER **
 ** ./src/scripts/models/data.ts
 **/